import type { TransactionItemDetail } from 'models';
import { Modal, message } from 'ui';
import { useUpdateTransactionItem } from 'features/transactions';
import { TestimonialEditForm, type TestimonialEditFormValues } from './testimonial-edit-form';

type P = {
  isOpened: boolean;
  onClose: () => void;
  testimonial: TransactionItemDetail;
};

const TestimonialEditModal = ({ isOpened, onClose, testimonial }: P) => {
  const { isPending: isLoading, mutate: updateTransactionItem } = useUpdateTransactionItem();

  const onSave = (values: TestimonialEditFormValues) => {
    updateTransactionItem(
      {
        anonymous: !values.displayName,
        id: testimonial.id,
        showTextContent: Boolean(values.reason),
        textContent: values.reason,
      },
      {
        onSuccess() {
          message.success('Testimonial successfully edited');
          onClose();
        },
      },
    );
  };

  return (
    <Modal isOpened={isOpened} maskClosable={false} onCancel={onClose} title="Edit testimonial" width="medium">
      <Modal.HugContent>
        <TestimonialEditForm isLoading={isLoading} onCancel={onClose} onSuccess={onSave} testimonial={testimonial} />
      </Modal.HugContent>
    </Modal>
  );
};

export default TestimonialEditModal;
